// utils/stringUtils.js

/**
 * Capitalizes the first letter of a string.
 * @param {string} str
 * @returns {string}
 */
function capitalize(str) {
  if (typeof str !== 'string' || !str.length) return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
}

/**
 * Capitalizes the first letter of each word in a string.
 * @param {string} str
 * @returns {string}
 */
function capitalizeWords(str) {
  if (typeof str !== 'string' || !str.length) return '';
  return str.split(' ').map(capitalize).join(' ');
}

/**
 * Checks if a string is null, undefined, or only whitespace.
 * @param {string} str
 * @returns {boolean}
 */
function isEmpty(str) {
  return typeof str !== 'string' || str.trim().length === 0;
}

/**
 * Checks if a string is null, undefined, or only whitespace.
 * @param {string} str
 * @returns {string}
 */
function appendPeriodIfMissing(str) {
  const trimmed = str.trim();
  return trimmed.endsWith('.') ? trimmed : trimmed + '.';
}

// Export all functions
export { capitalize, capitalizeWords, isEmpty, appendPeriodIfMissing };
